/*
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by Shivam Mishra <shivam.mishra@wakencode.com>, 7 2023
 *
 */

import {
  RotateLeftOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import {  DownloadOutlined } from "../../../antd";
import { UploadFile } from "antd";
import { PhotoSlider } from "react-photo-view";
import { useEffect, useMemo, useState } from "react";
import "react-photo-view/dist/react-photo-view.css";

interface IImageViewerProps {
  fileList: UploadFile<any>[];
  currentOpen: number;
  onClose: () => void;  
  onDownload: (index: number) => void;
}

export const ImageViewer = ({
  onClose,
  currentOpen,
  fileList,  
  onDownload,
}: IImageViewerProps) => {
  const [images, setImages] = useState<string[]>([]);
  const [index, setIndex] = useState(currentOpen || 0);

  useEffect(() => {
    const imagesList = fileList.map((item) => {
      return item.url;
    });

    setImages(imagesList as string[]);
  }, [fileList]);

  const fileName = useMemo(() => {
    const currentFileName =
      fileList[index].name ||
      fileList[index].url!.substring(fileList[index].url!.lastIndexOf("/") + 1);
    return currentFileName;
  }, [index]);

  return (
    <PhotoSlider
      images={images.map((item) => ({ src: item, key: item }))}
      visible={true}
      onClose={onClose}
      index={index}
      onIndexChange={setIndex}
      maskOpacity={0.8}
      toolbarRender={({ rotate, onRotate, onScale, scale }) => (
        <div
          style={{
            display: "flex",
            gap: "20px",
          }}
        >
          <span
            style={{
              position: "absolute",
              top: "20%",
              right: "50%",
            }}
          >
            {fileName}
          </span>
          <ZoomInOutlined
            key="zoom-in"
            className="image-viewer-icon"
            onClick={() => onScale(scale + 1)}
            title="Zoom in"
          />

          <ZoomOutOutlined
            key="zoom-out"
            className="image-viewer-icon"
            onClick={() => onScale(scale - 1)}
            title="Zoom out"
          />

          <RotateLeftOutlined
            key="rotate"
            className="image-viewer-icon"
            onClick={() => onRotate(rotate + 90)}
            title="Rotate"
          />

          <DownloadOutlined
            key="download"
            className="image-viewer-icon"
            onClick={() => onDownload(index)}
            title="Download"
          />
        </div>
      )}
    />
  );
};
